import { render, staticRenderFns } from "./MWList.vue?vue&type=template&id=8e04d616"
import script from "./MWList.vue?vue&type=script&lang=js"
export * from "./MWList.vue?vue&type=script&lang=js"
import style0 from "./MWList.vue?vue&type=style&index=0&id=8e04d616&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports